/**
 * This defines the theme properties for higher level page elements.
 *
 * Since this is a common theme constant, nothing here should reference colors directly and should
 * only refer to palette members.
*/

const _badgeBorderRadius = 18;

export const ThemeCommonPage = {
    dialog: {
        window: {
            backgroundColor: "defaultBackground"
        },
        header: {
            color: "palette.primary.reverse",
            backgroundColor: "palette.primary.darker",
            fontSize: "xlarge",
            fontBold: true
        }
    },
    cta: {
        color: "primary.reverse",
        backgroundColor: "primary"
    },
    tooltip: {
        backgroundColor: "#f9f9f9",
        borderColor: "strokeSecondary",
        borderRadius: 4,
        borderWidth: 1,
        color: "palette.default.base",
        padding: 8
    },
    menu: {
        favoriteImage: {
            name: "starFilled", // Can't use ImageName.starFilled because it's in images
            height: 16,
            width: 16,
            color: "transparent",
            strokeWidth: 1.5,
            marginRight: 4
        },
        leafNodeLabel: {
            minHeight: 16,
            paddingTop: 8,
            paddingBottom: 8
        },
        branchNode: {
            padding: 0,
            imageRotation: -90,
            imageProps: {
                name: "chevronDown",  // Can't use ImageName.chevronDown because it's in images
                height: 16,
                width: 16,
                padding: 0
            }
        }
    },
    badge: {
        borderRadius: _badgeBorderRadius
    },
    defaultBadge: {
        backgroundColor: "default",
        color: "default.reverse",
        borderRadius: _badgeBorderRadius
    },
    primaryBadge: {
        backgroundColor: "primary",
        color: "primary.reverse",
        borderRadius: _badgeBorderRadius
    },
    successBadge: {
        backgroundColor: "success",
        color: "success.reverse",
        borderRadius: _badgeBorderRadius
    },
    warningBadge: {
        backgroundColor: "warning",
        color: "warning.reverse",
        borderRadius: _badgeBorderRadius
    },
    errorBadge: {
        backgroundColor: "error",
        color: "error.reverse",
        borderRadius: _badgeBorderRadius
    },
    cautionBadge: {
        backgroundColor: "caution",
        color: "caution.reverse",
        borderRadius: _badgeBorderRadius
    },
    subtleBadge: {
        backgroundColor: "subtle",
        color: "subtle.reverse",
        borderRadius: _badgeBorderRadius
    }
}
